import React, { useState } from "react";
import { backendDeleteWithoutRefresh } from "../../../../helpers/callBackend";
import DraggableModal from "../../../generic/DraggableModal";
import StyledButton from "../../../generic/StyledButton";

const TeamDeleteModal = ({
  ucsId,
  currentUserCompanyPermissions,
  setUserCompanyPermissions,
  modalVisible,
  setModalVisible,
}) => {
  const [loading, setLoading] = useState(false);

  let displayName = "User name unknown";
  let selectedUcs = currentUserCompanyPermissions.find(
    (ucsObject) => ucsObject.id == ucsId
  );
  if (selectedUcs) {
    displayName = selectedUcs.first_name
      ? selectedUcs.first_name + selectedUcs.last_name
      : selectedUcs.email;
  }

  const deleteUcsObject = async (ucsId) => {
    const deletedUcsObject = await backendDeleteWithoutRefresh(
      "/api/landlord/permissions/",
      { id: ucsId }
    );

    if (deletedUcsObject.status == 200) {
      let newUcsObjects = [...currentUserCompanyPermissions];
      const deletedIdx = currentUserCompanyPermissions.findIndex(
        (ucsObject) => {
          if (ucsObject.id == ucsId) {
            return ucsObject;
          }
        }
      );
      newUcsObjects.splice(deletedIdx, 1);
      setModalVisible(false);
      setUserCompanyPermissions(newUcsObjects);
    }
  };
  return (
    <DraggableModal
      modalVisible={modalVisible}
      handleCancelModal={setModalVisible}
      modalTitle={`Are you sure you want to remove ${displayName}?`}
      content={`By clicking Delete below, ${displayName} will no longer have access to your team's dashboard. If you do not want to proceed or unsure, please click X on the upper right.`}
      actions={
        <StyledButton
          width="80%"
          label="Delete"
          customTheme="delete"
          fontSize={14}
          loading={loading}
          padding={0.25}
          onClick={() => {
            setLoading(true);
            deleteUcsObject(ucsId);
            setLoading(false);
          }}
        />
      }
    />
  );
};

export default TeamDeleteModal;
